import React, { useRef, useState, useCallback, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import Testimonial from "../components/testimonila/Testimonial";
import ParalexEffectSlider from "../components/ParalexEffectSlider/ParalexEffectSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import { Navigation, Autoplay } from "swiper/modules";
import FAQ from "../components/Fqas/FAQ";
import AIContactSection from "../components/ai-contact-section/AIContactSection";
import IndustryCuttingEdge from "../components/industry-cutting-edge/IndustryCuttingEdge";
import industryData from "../data/industryData";
import HireUs from "../components/hireUs/HireUs";
import IndustryDetailCard from "../components/industryDetailCard/IndustryDetailCard";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";

import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import OurServices from "../components/our-services/OurServices";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import { usaHometabItems, usaHometabs } from "../data/usa-home-stack-data";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import IndustryDetailCompliance from "../components/industry-details-compliance/IndustryDetailCompliance";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";


const IndustryDetailNew = () => {
  const { slug: slug } = useParams();
  const [filteredData, setFilteredData] = useState(null);

  const { t } = useTranslation("industries");
  const translatedTabData = t("tabData", { returnObjects: true });
  const staticHeading = t("staticHeading", { returnObjects: true });

  useEffect(() => {
    const matchingSlide = translatedTabData.find(
      (item) => String(item.slug) === String(slug)
    );
    setFilteredData(matchingSlide);
  }, [slug, translatedTabData]);

  // console.log(filteredData, "Here is the filtered data of indystry page");

  // SLIDER FUNCTIONS
  const sliderRef = useRef();

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // SLIDER FUNCTIONS

  const CtaContent = {
    heading: "Design. Build. Scale. Your AI Agent Journey Begins Now.",
    // subHeading: "See how our expert developers can help.",
    buttonText: "Schedule a Call",
    image: '/images/why-us-section/bottom-second-cta.avif'
  }

  const roadmapContent = {
    shortHeading: "Proven AI ML Development Roadmap",
    heading: "From Vision to <span>Execution</span> in 4 Weeks",
    description:
      "Kickstart your AI & ML projects faster with Bitsclan. From strategy to execution, we help you build powerful, scalable solutions that deliver results in just 3–4 weeks.",
    processData: [
      {
        title: "Plan Your AI Strategy & Team Setup",
        description: "Share your goals, timeline, & budget. We’ll design a detailed AI/ML strategy & define the perfect team structure to match your success metrics.",
        icon: "/images/roadmap-icons/ai-strategy.svg"
      },
      {
        title: "Assemble Skilled AI & ML Experts Quickly",
        description: "With the plan locked, we onboard top engineers & developers. Your dedicated team is ready to start delivering results within 3–4 weeks.",
        icon: "/images/roadmap-icons/assemble-skilled.svg"
      },
      {
        title: "Development, Testing & Implementation",
        description: "Our AI ML experts design, build, & rigorously test your solutions to ensure smooth functionality. Once validated, we implement them effectively, setting clear goals for reliable, future-ready results.",
        icon: "/images/roadmap-icons/development-strategy.svg"
      },
      {
        title: "Progress Tracking & Ongoing Support",
        description: "We monitor every milestone with measurable outcomes, keeping projects aligned with your standards. With continuous updates & dedicated support, your AI systems remain optimized & growth-focused.",
        icon: "/images/roadmap-icons/ongoing-support.svg"
      }
    ],
    cta: {
      text: "Book a Call",
      link: "https://calendly.com/bitsclan-it/30min?"
    }
  }

  // console.log(filteredData?.backgroundImage, "bg image");

  const { t: servicesSection } = useTranslation("ksaHome");
  const ksaHomehireServicesInsights = servicesSection("servicesInsights", { returnObjects: true, });
  const whyUsData = servicesSection("whyUs", { returnObjects: true, });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });


  return (
    <>
      <Helmet>
        <title>
          {filteredData?.metaTitle ||
            "Expert IT Solutions Tailored for Each Industry | Bitsclan"}
        </title>
        <meta
          name="description"
          content={
            filteredData?.metaDes ||
            "Our industry-specific IT solutions meet the unique challenges of your sector. We provide customized services that drive innovation & growth."
          }
        />
      </Helmet>

      <MegaMenu />

      {/* <div className="industry-page-image">
        <HirePageBanner
          mainHeading={filteredData?.bannerHeading}
          content={filteredData?.description}
          btnText={filteredData?.bannerBtnText}
          diffBannerBackgroundImage={filteredData?.backgroundImage}
          contactUsLink="/contact-us"
        />
      </div> */}

      <ServicesPageBanner
        shortHeading={slug}
        mainHeading={filteredData?.bannerHeading}
        description={filteredData?.description}
        icons={filteredData?.bannerIcons}
      />

      <TrustedPartner hideTrusted={true} />

      <OurServices buttonText="Let's Grow Togather"
        servicesCardsData={filteredData?.industryServices?.industryServicesSlides}
        shortHeading="What we do"
        mainHeading={filteredData?.industryServices?.heading}
        description={filteredData?.industryServices?.text}
      />

      <SoftwareCompanyCta content={CtaContent} />

      <NewCaseStudySection
        shortHeading={`Our ${slug} Case Studies`}
        heading="Enterprise Case Studies Validating Our Expertise"
        description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries."
      />

      <IndustryDetailCard
        HireUsData={filteredData?.industryServices?.industryServicesSlides}
        heading={"Our Solutions"}
        content={"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptate illum eveniet quia voluptatibus obcaecati, sint doloremque quis debitis! In reiciendis aperiam excepturi voluptatum quisquam optio voluptatem facere, numquam nostrum aspernatur delectus nemo! Quos quam tempora, asperiores provident aperiam voluptates itaque similique quis aspernatur quae adipisci, nostrum maxime. Nihil, eveniet unde."}
      />

      <CoverTheStack
        whereStart={"AI/ML"}
        tabs={usaHometabs}
        tabItems={usaHometabItems}
        mainHeading={
          "Don't worry! We've got the tech stack you're looking for!"
        }
        secondSubHeading={
          "We have experts in almost all major & common tech stacks. Our team is rapidly expanding, covering more programming languages & expertise. You can be confident you'll get the experts you need when you work with us."
        }
      />

      {/*HEALTH CARE COUNTER BOX*/}
      <div
        className="health-care-counter-box-wrap"
        style={{
          backgroundImage: `url(/images/industry-details/${filteredData?.statsSection?.backgroundImage})`,
        }}
      >
        <div className="health-care-counter-box">
          <div className="container">
            <div className="row">
              <div class="col-md-12">
                <h4 class="engagment-model-text">
                  {filteredData?.statsSection?.heading}{" "}
                  <span>{filteredData?.statsSection?.greenPart}</span>
                </h4>

                <h3 class="sub-heading-box w-75 m-auto">
                  {filteredData?.statsSection?.discription}
                </h3>
                <h4 class="health-card-sub-heading">
                  {filteredData?.statsSection?.subheading}{" "}
                  <span>{filteredData?.statsSection?.greenPartSubHeading}</span>
                </h4>
              </div>

              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="stats-number-wrapper">
                  {filteredData?.statsSection?.stats?.map((item, index) => (
                    <div className="stats-number" key={index}>
                      <h4 className="text-light">{item.count}</h4>
                      <p className="stats-number-text">{item?.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*HEALTH CARE COUNTER BOX*/}

      <NewRoadMap roadmapContent={roadmapContent} />

      {slug === "healthcare" && <SecurityFIrstSection />}

      <FAQ
        faqs={filteredData?.industryFaqs?.faqData}
        mainHeading={filteredData?.industryFaqs?.heading}
        subHeading={filteredData?.industryFaqs?.discription}
      />

      <SoftwareCompanyCta content={footerCtaContent} />
      <Footer />
    </>
  );
};

export default IndustryDetailNew;
